
(function($, B) {
    'use strict';

    var bmatch =  function(search, type) {
        var match = null;
        if (typeof search === 'string' && search !== '') {
            switch (type) {
                case 'sufix':
                    break;
                case 'contains':
                    match = new RegExp('(' + search + ')', 'g');
                    break;
                default:
                    match = new RegExp('\\b(' + search + '\\S*)', 'g');
            }
        }
        return match;
    };

    $.fn.getChildsHeight = function(){
        var childsHeight=0,
            $this = $(this);
        $this.children().each(function(){
            childsHeight+=$(this).outerHeight(true);
        });
        return childsHeight;
    };

    $.fn.removeClassSearch = function(search, type) {
        var classMatch = bmatch(search, type);
        if (classMatch) {
            this.removeClass(function() {
                return (this.className.match(classMatch) || []).join(' ');
            });
        }
        return this;
    };        

    $.fn.changeIcon=function(icon){//font canvas
        if(typeof icon === 'string' && icon!==''){
            var iClass= icon.indexOf('icon-')< 0 ? 'icon-'+icon : icon,
                $i=this.hasClass('icon') ? this : this.find('.icon');
                $i.removeClassSearch('icon-').addClass(iClass);
        }
        return this;
    };

    $.extend(true, B, {
        web:{
            onReady:{
    
            },
            onScroll:{

            },
            onResize:{

            },
            toInit:{
            }, 
            selectors:{
                header: '#header-b',
                primaryMenu: 'nav.primary-menu'
            },
            widgets:{    
            },
            $elements:{
            },
            data:{
            },
            getElements:function(selectors, target, $container){
                target = target || {};
                for(var k in selectors){
                    target[k]=$container ? $container.find(selectors[k]) : ($(selectors[k]));
                    target[k] = target[k].length > 0 ? target[k] : null;
                }
            },
            init:function(){
                this.getElements(this.selectors, this.$elements);
                for(var k in this.toInit){
                    if(this.toInit[k]){
                        this.widgets[k].init();
                    }
                }
            },
            documentReady:function(){
                B.runFunctions(B.web.onReady);
            },
            windowScroll:function(){
                B.runFunctions(B.web.onScroll);
            },
            windowResize:function(){
                B.runFunctions(B.web.onResize);
            }
        }
    });
        
    $(document).ready(function() { 
        B.web.init();
        B.web.documentReady();
        $(window).on('scroll', B.web.windowScroll);
        $(window).on('resize', B.web.windowResize);
        // $(window).on('scroll', function(){
        //     B.web.windowScroll();
        // });
        // $(window).on('resize', function(){
        //     B.web.windowResize();
        // });
    });


    $.fn.fill = function(data, options) {
        var $this = $(this),
            o = $.extend(
                true,
                {
                    empty: '',
                    templates: {
                    }
                },
                options || {},
                $this.data() || {}
            ),
            _convert = function(field, value) {
                var val = value !== undefined ? value : field.value,
                    fo = field.options || {},
                    disp = B.str.is(fo.disp) ? fo.disp : 'name';
                if (val === undefined || val === null) {
                    val = fo.empty || o.empty;
                }else if(fo.convert){
                    val = B.convert(val, fo.convert);
                }               
                if(disp && B.obj.is(val)){
                    var val1 = B.obj.getValue(val, disp);
                    if(val1 !== undefined){
                        val = val1;
                    }  
                }
                    
                return val;
            },
            _show = function(field, value) {
                var val = value !== undefined ? value : field.value,
                    signal = B.obj.getValue('options.signal', field),
                    _html = function(){
                        var html;
                        if (B.obj.is(val)) {
                            html = field.tmpl 
                                ? $(field.tmpl).fill(val, field.ecn, o) 
                                : JSON.stringify(val);
                        }else if( field.tmpl ) {
                            html = field.tmpl.indexOf('data-container') > 0 //jeśli prototyp przeznaczony na tabelę ale wartość nie jest tabelą
                                ? val
                                : field.tmpl.replace('__v__', val);
                        }else{
                            html = val;
                        }       
                        return html;
                    };
                if(field.options.disp !== 'fill' ){
                    val = _convert(field, val);
                }
                if (signal) {
                    field.$element.html(signal);
                }else{
                    field.$element.append(_html());
                }
            },
            _getValue=function(key, field, def){
                def = def || '';
                if(key){
                    var value = field.value;
                    if(key.indexOf('.') == 0){
                        key = key.slice(1);
                        value = field.data;
                    }
                    return B.obj.getValue(key, value, def || '');
                }
                // return key ? B.obj.getValue(key, value, def || '') : value;
                return field.value;
            },
            _traversData = function(field) {
                var names = field.options.name.split('.'); //nazwa zmiennej w obiekcie zagłębienie rozdzielone . (obj.obj1.obj2.val)
                for (var i = 0; i < names.length; i++) {
                    field.fullname = names[i];
                    field.value = B.getValue(field.value, field.fullname);                   
                }
                return field;
            },
            _valueToStr=function(value){
                return B.obj.is(value) ? JSON.stringify(value) : value;
            },
            _setAttr=function($element, name, value){
                if(null !== value){
                    $element.attr(name, _valueToStr(value));
                }
            },
            _setAttrValues = function(field){
                var attr = B.obj.getValue('options.attr', field, []);
                for (var i in attr) {
                    _setAttr(field.$element, attr[i].name, _getValue(attr[i].key, field, attr[i].def ));
                }
            },
            _setDataValues = function(field) {
                var nv = B.obj.getValue('options.values', field, [] );
                for (var i in nv) {
                    var val=_getValue(nv[i].key, field);
                    _setAttr(field.$element, 'data-' + nv[i].name, val);
                    field.$element.data(nv[i].name, val);
                }
            },
            _disp=function(field){
                var fo = field.options,
                    $f = field.$element;
                if (o.excludeFields && o.excludeFields.indexOf(fo.name) >= 0) {
                    return true;
                }
                _traversData(field);
                _setAttrValues(field);
                _setDataValues(field);
                if (fo.disp) {
                    field.tmpl = fo.tmpl || o.templates[fo.tmplName || field.fullname];                   
                    if (!fo.notClear){
                        $f.empty();
                    }
                    if(fo.prefixContent){
                        $f.append(fo.prefixContent);
                    }
                    if (Array.isArray(field.value)) {
                        if (field.tmpl) {
                            var $c = $(field.tmpl);
                            if ($c.data('container') !== undefined) {
                                //sprawdzenie czy jest container
                                $f.append($c);
                                $f = $c;
                                field.tmpl = o.templates[field.fullname + '_entry'] || $c.data('tmpl');
                            }
                        }
                        for (var i = 0, ien = field.value.length; i < ien; i++) {
                            _show(field, field.value[i]);
                        }
                    } else {
                        _show(field);
                    }
                }
            };
        if(o['name']){
            _disp({ 
                $element: $this,
                value: data,
                data: data,
                tmpl: false,
                options: $.extend(true , { disp: true, name: o['name'] }, o)
            });   
        }else{
            var f={ $element: $this, value: data, options: o };
            _setAttrValues(f);
            _setDataValues(f);
        }

        $this.find('[data-name]').each(function() {
            var $field = $(this),
                fo = $field.data();
            _disp({ 
                $element: $field,
                value: data,
                data: data,
                tmpl: false,
                options: $.extend(true , { disp: true, name: fo['name'] }, fo )
            });
        });
        return $this;
    };


})(jQuery, Bajt);
